import { Container } from '@mui/material';
import { withStyles } from '@mui/styles';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('md')]: {
            paddingLeft: '16px',
            paddingRight: '16px',
        },
        paddingTop: '28px',
        paddingBottom: '5rem',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
});

function PageContainer({ classes, children }) {
    return (
        <Container maxWidth="xl" className={classes.container}>
            {children}
        </Container>
    );
}

export default withStyles(styles)(PageContainer);
